export default "__VITE_PUBLIC_ASSET__1ac87927__"